import NumberFormatOptions = Intl.NumberFormatOptions;

export const BD_NUMBER_FORMATTER_OPTIONS_DEFAULT: Intl.NumberFormatOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
}

export class BdNumberFormatter {

  public static convertAngularFormatString(formatStr: string): NumberFormatOptions {
    if (!formatStr.match(/[0-9].[0-9]-[0-9]/)) {
      throw new Error('Invalid format string.');
    }

    const fractionSplit = formatStr.split('.')[1].split('-');
    const minimumFractionDigits = parseInt(fractionSplit[0]);
    const maximumFractionDigits = parseInt(fractionSplit[1]);

    return {
      minimumFractionDigits,
      maximumFractionDigits
    };
  }

  /**
   * Returns the given value rounded and formatted as locale string using the Intl.NumberFormat functionality.
   * Returns an empty string for falsy values.
   *
   * @param value
   * @param options - default is fraction format `1.0-2`
   * @param languages - country codes to use for formatting, default is `navigator.languages` (Node.js >= 21 fills it from the host locale) or `['en-US']` without `navigator`
   */
  public static format(
      value: number,
      options: NumberFormatOptions = BD_NUMBER_FORMATTER_OPTIONS_DEFAULT,
      languages: string[] = typeof navigator !== 'undefined' ? navigator.languages as string[] : ['en-US']
  ): string {
    let formattedValue = '';

    if (!isNaN(value) && value != null) {

      formattedValue = new Intl
        .NumberFormat(languages, options)
        .format(value);
    }

    return formattedValue;
  }
}
